import React from 'react';
import { ministryInfo } from '../mock';
import { Heart, Mail, Phone, Instagram } from 'lucide-react';

// Custom TikTok icon component
const TikTokIcon = ({ size = 16, style = {} }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor"
    style={style}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer style={{ 
      background: '#8B4513', 
      color: '#FFF8DC',
      padding: '60px 0 20px 0'
    }}>
      <div className="container">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '40px',
          marginBottom: '40px'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
              <Heart size={20} style={{ color: '#FFF8DC' }} />
              <h3 className="heading-3" style={{ color: '#FFF8DC' }}>
                {ministryInfo.name}
              </h3>
            </div>
            
            <p className="body-regular" style={{ 
              color: '#D2B48C', 
              marginBottom: '16px',
              lineHeight: 1.6
            }}>
              {ministryInfo.tagline}
            </p>
            
            <p className="body-small" style={{ color: 'var(--bg-secondary)' }}>
              We exist to repair the breach where lies and brokenness have taken root, and restore lives on the foundation of Truth.
            </p>
          </div>
          
          <div>
            <h4 className="heading-3" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
              Quick Links
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                { label: 'Home', href: '#home' },
                { label: 'About Us', href: '#about' },
                { label: 'Our Services', href: '#services' },
                { label: 'Daily Devotionals', href: '#devotionals' },
                { label: 'Support Us', href: '#donations' },
                { label: 'Contact', href: '#contact' }
              ].map((link) => (
                <li key={link.label} style={{ marginBottom: '8px' }}>
                  <a
                    href={link.href}
                    className="body-small"
                    style={{ 
                      color: 'var(--bg-secondary)', 
                      textDecoration: 'none',
                      transition: 'color 0.2s ease'
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.querySelector(link.href);
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--bg-secondary)'}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="heading-3" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
              Our Services
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                '1:1 Life Coaching (FREE first session)',
                '12-Week Transformation Program',
                'Prayer Ministry (Always FREE)',
                'Daily Devotionals (Always FREE)',
                'Bible Studies (Coming Soon)',
                'Community Care Pop-Ups (Coming Soon)'
              ].map((service) => (
                <li key={service} style={{ marginBottom: '8px' }}>
                  <span className="body-small" style={{ color: 'var(--bg-secondary)' }}>
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="heading-3" style={{ color: 'var(--bg-primary)', marginBottom: '16px' }}>
              Contact Info
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} style={{ color: 'var(--bg-secondary)' }} />
                <a
                  href={`mailto:${ministryInfo.contact.email}`}
                  className="body-small"
                  style={{ color: 'var(--bg-secondary)', textDecoration: 'none' }}
                >
                  {ministryInfo.contact.email}
                </a>
              </div>
              
              <div style={{ marginTop: '8px' }}>
                <h5 className="body-small" style={{ color: 'var(--bg-primary)', marginBottom: '8px', fontWeight: '600' }}>
                  Follow Us
                </h5>
                <div style={{ display: 'flex', gap: '16px' }}>
                  <a
                    href={`https://www.tiktok.com/@${ministryInfo.socialMedia.tiktok}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: 'var(--bg-secondary)', 
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      transition: 'color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--bg-secondary)'}
                  >
                    <TikTokIcon size={16} />
                    <span className="body-small">TikTok</span>
                  </a>
                  
                  <a
                    href={`https://www.instagram.com/${ministryInfo.socialMedia.instagram}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      color: 'var(--bg-secondary)', 
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      transition: 'color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--bg-primary)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--bg-secondary)'}
                  >
                    <Instagram size={16} />
                    <span className="body-small">Instagram</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div style={{ 
          borderTop: '1px solid var(--bg-secondary)',
          paddingTop: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p className="body-small" style={{ color: 'var(--bg-secondary)' }}>
            © 2024 {ministryInfo.name}. All rights reserved. Built with love and faith.
          </p>
          
          <button
            onClick={scrollToTop}
            className="btn-secondary"
            style={{ 
              color: 'var(--bg-primary)',
              background: 'none',
              border: 'none',
              fontSize: '12px'
            }}
          >
            Back to Top ↑
          </button>
        </div>
      </div>
    </footer>
  );
};